import {useCallback, useSyncExternalStore} from 'react';
import {useSelector} from 'react-redux';
import {selectTotalGamesPlayed} from '../../redux/reducers/privateStateReducer/selectors';

// Описание выбранного строения в футере (справа от тулбара строительства)
// нужно новичку, который еще не выучил строения, а опытному игроку только
// занимает место. Поэтому оно переключается кнопкой «?» в шапке футера, а без
// явного выбора включено, пока сыграно меньше NOVICE_GAMES_PLAYED партий.
// Выбор запоминается на этом устройстве
export const NOVICE_GAMES_PLAYED = 5;
export const BUILDING_HINTS_STORAGE_KEY = 'strategikon.buildingHintsVisible';

// Хранилище недоступно (приватный режим, запрет сайта) — живем выбором в памяти
let memoryValue = null;
const listeners = new Set();

const readStoredValue = () => {
  try {
    const raw = window.localStorage.getItem(BUILDING_HINTS_STORAGE_KEY);
    if (raw === 'true') return true;
    if (raw === 'false') return false;
  } catch (error) {
    // см. memoryValue
  }
  return memoryValue;
};

const writeStoredValue = (value) => {
  memoryValue = value;
  try {
    window.localStorage.setItem(BUILDING_HINTS_STORAGE_KEY, String(value));
  } catch (error) {
    // см. memoryValue
  }
  listeners.forEach((listener) => listener());
};

const subscribe = (listener) => {
  listeners.add(listener);
  return () => listeners.delete(listener);
};

/** Только для тестов: забыть выбор */
export const resetBuildingHintsChoice = () => {
  memoryValue = null;
  try {
    window.localStorage.removeItem(BUILDING_HINTS_STORAGE_KEY);
  } catch (error) {
    // см. memoryValue
  }
  listeners.forEach((listener) => listener());
};

/**
 * Без явного выбора — по опыту игрока; счетчик неизвестен (гость) — считаем
 * новичком
 * @param {boolean|null} storedValue
 * @param {number|null} gamesPlayed
 * @returns {boolean}
 */
export const resolveBuildingHintsVisible = (storedValue, gamesPlayed) => (
  storedValue ?? (gamesPlayed == null || gamesPlayed < NOVICE_GAMES_PLAYED)
);

/**
 * @returns {[boolean, function(): void]} показывать ли описание и переключатель
 */
export const useBuildingHints = () => {
  const storedValue = useSyncExternalStore(subscribe, readStoredValue, readStoredValue);
  const gamesPlayed = useSelector(selectTotalGamesPlayed);
  const isVisible = resolveBuildingHintsVisible(storedValue, gamesPlayed);
  const toggle = useCallback(() => writeStoredValue(!isVisible), [isVisible]);
  return [isVisible, toggle];
};
